<template>
  <div class="text-start mx-1">
    <v-dialog v-model="isOpen" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-icon small color="blue darken-2" class="mx-2" v-bind="attrs" v-on="on">wallet</v-icon>
      </template>
      <v-card :loading="isLoading">
        <v-card-title class="text-h5 lighten-2">Adjust wallet</v-card-title>
        <v-card-text>
          <v-container>
            <div>
              Current amount: <b>{{ formattedWallet }}</b>
            </div>
            <v-radio-group v-model="walletOperation" row>
              <v-radio label="Add" value="add" color="green"></v-radio>
              <v-radio label="Deduct" value="deduct" color="red"></v-radio>
            </v-radio-group>
            <v-layout row wrap class="ml-0 mb-4">
              <v-flex xs12 sm4>
                <v-text-field
                  v-model="changeAmount"
                  dense
                  label="Amount"
                  prefix="฿"
                  type="number"
                  :disabled="walletOperation === null"
                />
              </v-flex>
              <v-flex xs12 sm8>
                <v-text-field
                  v-model="operationReason"
                  dense
                  label="Reason"
                  :disabled="walletOperation === null"
                  class="ml-4"
                />
              </v-flex>
            </v-layout>
            <div class="red--text" v-show="!isEnoughMoney">*Not enough money in wallet to deduct</div>
            <div class="red--text" v-show="!isAmountValid">*Amount must be positive number</div>
            <div class="red--text" v-show="!isReasonValid">*Reason is required</div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleClose">Close</v-btn>
          <v-btn color="primary" text :disabled="!isInputValid" @click="handleSubmit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import userWalletService from '../../../services/userWallet';

export default {
  name: 'AdjustWalletDialog',
  props: ['userId', 'wallet', 'onSuccess'],
  data() {
    return {
      isLoading: false,
      isOpen: false,
      comment: '',
      walletOperation: null,
      operationReason: '',
      changeAmount: 0,
    };
  },
  methods: {
    handleClose() {
      this.isOpen = false;
    },
    handleSubmit() {
      this.isLoading = true;
      userWalletService
        .update(this.userId, this.walletOperation, this.changeAmount, this.operationReason)
        .then(() => {
          this.isOpen = false;
          if (this.onSuccess) {
            this.onSuccess();
          }
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  computed: {
    formattedWallet() {
      return new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(this.wallet / 100);
    },
    isEnoughMoney() {
      return (
        this.walletOperation !== 'deduct' ||
        (this.walletOperation === 'deduct' && this.wallet / 100 >= this.changeAmount)
      );
    },
    isReasonValid() {
      return this.operationReason !== '';
    },
    isAmountValid() {
      return this.changeAmount > 0;
    },
    isInputValid() {
      return this.isAmountValid && this.isReasonValid && this.isEnoughMoney;
    },
  },
};
</script>
